(function () {
  'use strict';

  function formatAmount(cents) {
    var value = Math.round(Number(cents)) / 100;
    if (isNaN(value)) return '';
    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1];
  }

  window.vfFormatMoneyEuro = function (cents) {
    if (cents == null || cents === '' || isNaN(cents)) return '';
    return formatAmount(cents) + '\u00a0€';
  };

  window.vfFormatMoney = window.vfFormatMoneyEuro;

  window.vfNormalizeMoneyString = function (str) {
    if (!str) return '';
    var s = String(str).trim();
    if (/^€\s*/.test(s)) return s.replace(/^€\s*/, '').trim() + '\u00a0€';
    if (/^EUR\s*/i.test(s)) return s.replace(/^EUR\s*/i, '').trim() + '\u00a0€';
    return s;
  };
})();
